import { cleanObjFromEmptyVal } from "./helpfulFunctions";

export const isExternalURL = (url: string) => url.match(/http[s]?\/\//i);
export const isExternalModifiedURL = (url: string) =>
  url?.match(/http[s]?:\/\//i);
export const getQueryParams = (query: string | object) => {
  const cleanQuery = checkIfObj(query) ? cleanObjFromEmptyVal(query) : query;
  const params = new URLSearchParams(cleanQuery);
  return params;
};

export const getCorrectIconUrl = ({ genImgUrl, cdnUrl }, image) =>
  isExternalModifiedURL(genImgUrl(image))
    ? genImgUrl(image)
    : cdnUrl + genImgUrl(image);

const checkIfObj = (el) =>
  typeof el === "object" && !Array.isArray(el) && el !== null;

export const checkIsFilterValueExist = (value) => {
    return Array.isArray(value)
      ? value.length > 0 && value[0] !== "all"
      : !!value && value !== "all";
  };

export const buildFilter = (filter) => {
  const assembledFilter = {};

  for (const [key, value] of Object.entries(filter) as any) {
    if (checkIsFilterValueExist(value)) {
      assembledFilter[key] = value;
    }
  }

  return assembledFilter;
};
